// FULL POPUP STUFF

function checkScrollbar() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function bodyStopScroll() {
  const scrollWidth = checkScrollbar();
  const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_noscrol_padding { padding-right: ${scrollWidth}px; }
        .js_noscrol_margin { margin-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
  if (!document.querySelector('#scrollStuff')) {
    document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  }
  document.body.classList.add('noscroll');
}
function bodyRemoveStopScroll() {

  document.head.querySelectorAll('#scrollStuff').forEach(item => {
    item.remove();
  });

  document.body.classList.remove('noscroll');
}
// ==============



// let's get this party started
document.addEventListener('DOMContentLoaded', function () {





  // STUFF ON SCROLL
  function onScroll() {
    // detect scroll
    const scrolledGap = 0;
    const scrollTop = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    scrollTop > scrolledGap
      ? document.body.classList.add('m-scrolled')
      : document.body.classList.remove('m-scrolled');
    // =========
  }
  onScroll();
  let throttlescroll;
  window.addEventListener('scroll', function () {
    clearTimeout(throttlescroll)
    throttlescroll = setTimeout(function () {
      onScroll();
    }, 50)
  }, false)
  // ========================


  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = '';
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }

        if (toggleTarget) {
          if (toggleTarget.classList.contains('js_toggle')) {
            toggleTarget.querySelectorAll('.js_toggle_trigger').forEach(item => {
              item.classList.toggle('m-active');
            });
          }
          else {
            trigger.classList.toggle('m-active');
          }
          toggleTarget.classList.toggle('m-active');
        }
        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });
  // ========================



  document.querySelectorAll('.js_hoverclick').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      trigger.classList.remove('m-hoverclick-hold');
      if (!trigger.classList.contains('m-active')) {
        trigger.classList.add('m-active');
      } else {
        trigger.classList.remove('m-active');
        trigger.classList.add('m-hoverclick-hold');
        trigger.blur();
      }

    });
    trigger.addEventListener('mouseleave', (e) => {
      trigger.classList.remove('m-hoverclick-hold');
    });
  });



  // FULL POPUP STUFF

  document.querySelectorAll('.js_popup_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));

      if (popupTarget) {

        bodyStopScroll();
        popupTarget.classList.add('m-active');

        trigger.classList.add('focusHolder');

        setTimeout(() => {
          popupTarget.setAttribute('tabindex', '-1');
          popupTarget.focus();
          popupTarget.blur();
          popupTarget.removeAttribute('tabindex');
        }, 500);
      }
    });
  });


  document.querySelectorAll('.js_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });


  let isEsc = false;
  document.addEventListener('keyup', function (event) {
    if (event.key === "Escape") {
      isEsc = true;
      closePopup();
    }
  });

  function closePopup() {
    const activePopup = document.querySelector('.js_popup.m-active');
    if (activePopup) {
      activePopup.classList.remove('m-active');
      setTimeout(() => {
        bodyRemoveStopScroll();

        const focusTarget = document.querySelector('.focusHolder');
        // if (focusTarget) {
        //   focusTarget.focus();
        //   if (!isEsc) {
        //     focusTarget.blur();
        //   }
        //   focusTarget.classList.remove('focusHolder');
        // }

        if (focusTarget) {
          if (focusTarget.closest('.swiper')) {
            focusTarget.closest('.swiper').setAttribute('tabindex', '-1');
            focusTarget.closest('.swiper').focus();
            focusTarget.closest('.swiper').blur();
          }
          else {
            focusTarget.focus();
            if (!isEsc) {
              focusTarget.blur();
            }
          }
          focusTarget.classList.remove('focusHolder');
        }

        isEsc = false;
      }, 300);
    }
    else {
      isEsc = false;
    }
  }


  // ==========================


  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!stopscrollHold) {
        stopscrollHold = true;
        if (!document.body.classList.contains('noscroll')) {
          bodyStopScroll();
        } else {
          setTimeout(() => {
            bodyRemoveStopScroll();
          }, 500);
        }
        setTimeout(() => {
          stopscrollHold = false;
        }, 500);
      }
    });
  });


  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (document.head.querySelector('#scrollStuff')) {
          bodyRemoveStopScroll();
        }

      }, 150)
    }
  }, false)




});


// =================================================
// =================================================
// =================================================

